import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";

const Wine50OffEtc2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <Wine50OffDiv>
      <Hero
        bgImage="promotions/dining/wine-50-oof-etc-2025/50-off-wine-header-image-1600x542px.jpg"
        buttonSettings={null}
        image={`promotions/dining/wine-50-oof-etc-2025/50-off-wine-logo-2400x1855-${i18n.language}.png`}
        darkenBg={0}
        description={t("diningPromos.wine50OffEtc2025.hero.title")}
        descriptionBgColor="#0000004d"
      />
      <EventFinished
        scheduleKeyName="wine50OffEtc2025"
        eventType="promotion"
      />
      <MainContentDiv>
        <container-div>
          <Row className="g-4 mb-5" xs={1} md={2}>
            <Col>
              <SubTitleSection
                as={"h2"}
                subTitle={t("diningPromos.wine50OffEtc2025.content.subtitle")}
              />
              <ReactMarkdown className="desc">
                {t("diningPromos.wine50OffEtc2025.content.description")}
              </ReactMarkdown>
            </Col>
            <Col className="pt-md-4">
              <ResponsiveImage
                src={`promotions/dining/wine-50-oof-etc-2025/50-off-wine-homepage.jpeg`}
                alt={t("diningPromos.wine50OffEtc2025.hero.title")}
              />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
      <container-div>
        <center-content>
          <p className="small">
            {t("diningPromos.wine50OffEtc2025.content.smallText")}
          </p>
        </center-content>
      </container-div>
    </Wine50OffDiv>
  );
};

const Wine50OffDiv = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
    max-width: 1100px;
    word-wrap: break-word;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #e70a02;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background: rgba(0, 0, 0, 0.5);
  }
  height: auto;
  width: 100%;
  text-align: left;
  .p_1 strong {
    white-space: nowrap;
  }
  .desc strong {
    color: #aaa09f;
  }
  p {
    margin-bottom: 1rem;
  }
`;

export default Wine50OffEtc2025;
